import { IPageSetting } from "../../../model/respone/category/IPageSetting";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";



export const ePageSettingActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IPageSetting[],
    LOAD_ERROR: "",

    SAVE_START: {} as IPageSetting,
    SAVE_SUCCESS: {} as IPageSetting,
    SAVE_ERROR: "",

}
export const ePageSettingActionTypeIds = generateActionTypeIds(ePageSettingActionTypeDefine, "PAGE_SETTING")
export type IPageSettingActionType = IGenericActionType<typeof ePageSettingActionTypeDefine, "PAGE_SETTING">